/* OBC - Omnisend back-in-stock waitlist.

   Palo Alto's sold-out flow (theme.js, onSubmitHandler) submits the
   "Notify Me When It's Available" popup through Shopify's contact form, which
   only emails the store's contact address. It creates no contact and captures
   no marketing consent, so those sign-ups cannot be segmented.

   This intercepts that submit and does one of two things instead:
     - REDIRECTS: send the customer to a dedicated waitlist page.
     - HANDLES:   open an Omnisend form in place (FORM_ID).
   A handle in REDIRECTS wins over HANDLES.

   The theme's own condition (theme.js) is:
     formWrapper.classList.contains('variant--soldout')
     && submitButton.hasAttribute('data-notification-popup')
   It is mirrored exactly below, so an in-stock product is never touched and
   Add to Cart is left completely alone.

   FORM_ID is the Omnisend form's ID (the value used with the 'openForm'
   custom trigger). Current value is the 'Wedding Planner Back in Stock' popup.
   If FORM_ID is emptied, the HANDLES path goes back to the theme's original
   popup; REDIRECTS keeps working either way.

   Add a handle to HANDLES or REDIRECTS to extend this to another product. */
(function () {
  var FORM_ID = '6aac73ecd5ec6ef7d597faac';

  var HANDLES = ['wedding-planner'];

  /* Sold-out button sends the customer to a page instead of opening a form. */
  var REDIRECTS = {
    '2027-weekly-diary': '/pages/2027-waitlist',
    '2027-daily-diary': '/pages/2027-waitlist',
    '2027-weekly-diary-bundle': '/pages/2027-waitlist'
  };

  function redirectFor(handle) {
    if (!handle) { return null; }
    return Object.prototype.hasOwnProperty.call(REDIRECTS, handle)
      ? REDIRECTS[handle]
      : null;
  }

  function productHandleFor(form) {
    var host = form.closest('[data-product-handle]');
    if (host) { return host.getAttribute('data-product-handle'); }

    var button = form.querySelector('[data-handle]');
    return button ? button.getAttribute('data-handle') : null;
  }

  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!form || typeof form.matches !== 'function') { return; }
      if (!form.matches('form[data-product-form]')) { return; }

      /* In stock: do nothing, so Add to Cart behaves normally. */
      var wrapper = form.closest('[data-form-wrapper]');
      if (!wrapper || !wrapper.classList.contains('variant--soldout')) { return; }

      var button = form.querySelector('[data-notification-popup]');
      if (!button || button.hasAttribute('disabled')) { return; }

      var handle = productHandleFor(form);
      var redirect = redirectFor(handle);

      if (!redirect) {
        if (!FORM_ID) { return; }
        if (HANDLES.indexOf(handle) === -1) { return; }
      }

      event.preventDefault();
      event.stopPropagation();
      if (event.stopImmediatePropagation) { event.stopImmediatePropagation(); }

      if (redirect) {
        window.location.href = redirect;
        return;
      }

      window.omnisend = window.omnisend || [];
      window.omnisend.push(['openForm', FORM_ID]);
    },
    true
  );
})();